import Offer from '../../../types/Offer.interface';

const getOfferLocationsLabel = (offer: Offer) => {
  if (!offer?.locations?.length) return 'no locations';
  if (offer.locations.length === 1) return offer.locations[0].name;
  return `${offer.locations.length} locations`;
};

export default getOfferLocationsLabel;
